import {
    SUCCESS_GET_ALL_CLIENTS,
    FAILED_GET_ALL_CLIENTS,
    SUCCESS_CREATE_CLIENT,
    FAILED_CREATE_CLIENT,
    SUCCESS_UPDATE_CLIENT,
    FAILED_UPDATE_CLIENT,
    SUCCESS_GET_CLIENT,
    FAILED_GET_CLIENT,
    SUCCESS_GET_CLIENT_FPS,
    FAILED_GET_CLIENT_FPS,
    SUCCESS_SAVE_CLIENT_FPS,
    FAILED_SAVE_CLIENT_FPS,
    SUCCESS_GET_SUBCLIENTS,
    FAILED_GET_SUBCLIENTS,
    SUCCESS_UPDATE_SUBCLIENT,
    FAILED_UPDATE_SUBCLIENT,
} from '../constants/clientConstants';

const defaultState = {
    clients: [],
    client: {},
    clientFPs: [],
    errorMessage: '',
    subClients: [],
};

export const ClientReducer = (state = defaultState, { type, payload, errorMessage }) => {
    switch (type) {        
        case SUCCESS_GET_ALL_CLIENTS:
            return {
                ...state,
                clients: payload,
                errorMessage: null,
            };
        case SUCCESS_GET_CLIENT:
            return {
                ...state,
                client: payload,
                errorMessage: null,
            };
        case SUCCESS_GET_CLIENT_FPS:
        case SUCCESS_SAVE_CLIENT_FPS:
            return {
                ...state,
                clientFPs: payload,
                errorMessage: null,
            };
        case SUCCESS_GET_SUBCLIENTS:
            return {
                ...state,
                subClients: payload,
                errorMessage: null,
            };
        case SUCCESS_UPDATE_SUBCLIENT:
            return {
                ...state,
                errorMessage: null,
            };
        case SUCCESS_CREATE_CLIENT:
        case FAILED_CREATE_CLIENT:
        case SUCCESS_UPDATE_CLIENT:
        case FAILED_UPDATE_CLIENT:
        case FAILED_GET_CLIENT:
        case FAILED_GET_ALL_CLIENTS:
        case FAILED_GET_CLIENT_FPS:
        case FAILED_SAVE_CLIENT_FPS:
        case FAILED_GET_SUBCLIENTS:
        case FAILED_UPDATE_SUBCLIENT:
            return {
                ...state,
                errorMessage: errorMessage
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducers/clientReducer.js